<template>
    <div class="footer">
        <div class="logo-box">
            <img class="logo" src="../assets/logo-footer.webp" alt="PT WAHANA PENGEMBANGAN USAHA Logo" />
            <div class="logo-text">PT WAHANA PENGEMBANGAN USAHA</div>
        </div>
        <div class="main">
            <div class="pages">
                <div class="title">PAGES</div>
                <div class="item" v-for="item in pageList" :key="item" @click="handleClick(item.path)">
                    {{ item.name }}
                </div>
            </div>
            <div class="contact-list">
                <div class="contact" v-for="(item, index) in list" :key="index">
                    <img class="item-icon" :src="item.icon" alt="">
                    <div class="item-text">{{ item.title }}</div>
                </div>
            </div>
        </div>
        <div class="bottom">
            © 2026 Copyright belongs to PT WAHANA PENGEMBANGAN USAHA
        </div>
    </div>
</template>
<script setup>
import { useRouter } from "vue-router";
const router = useRouter();
const pageList = [
    {
        name: 'HOME',
        path: '/home'
    },
    {
        name: 'SERVICES',
        path: '/service'
    },
    {
        name: 'INTRODUCTION',
        path: '/about'
    },
    {
        name: 'CONTACT',
        path: '/contact'
    },
];
const list = [
    {
        title: 'contact@wahanausaha.com',
        icon: require('../assets/footer-icon1.webp')
    },
    {
        title: `+62 085177876941`,
        icon: require('../assets/footer-icon2.webp')
    },
    {
        title: 'JL. SABANG NO. 25, Kel. , Kec. , Kota Bandung, Prop. Jawa Barat',
        icon: require('../assets/footer-icon3.webp')
    },
];
const handleClick = (path) => {
    router.replace(path);
    scrollTo(0, 0);
};
</script>
<style lang="less" scoped>
.footer {
    width: 100%;
    padding: 0 230px;
    box-sizing: border-box;
    background: #181818;

    .logo-box {
        padding-top: 32px;
        padding-left: 100px;
        display: flex;
        align-items: center;
        margin-bottom: 32px;

        .logo {
            width: 51px;
            height: 51px;
            object-fit: cover;
            margin-right: 19px;
        }

        .logo-text {
            font-weight: bold;
            font-size: 11px;
            color: #FFFFFF;
            line-height: 21px;
        }
    }

    .main {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-left: 100px;
        padding-bottom: 30px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.31);

        .pages {
            max-width: 86px;

            .title {
                font-weight: bold;
                font-size: 15px;
                color: #FFFFFF;
                line-height: 15px;
                margin-bottom: 15px;
            }

            .item {
                font-weight: bold;
                font-size: 11px;
                color: #FFFFFF;
                line-height: 12px;
                margin-bottom: 10px;
                cursor: pointer;
            }
        }

        .contact-list {
            flex: 1;
            display: flex;
            flex-direction: column;
            margin-left: 389px;

            .contact {
                display: flex;
                justify-content: start;
                align-items: center;
                margin-bottom: 20px;

                .item-icon {
                    width: 27px;
                    height: 27px;
                    object-fit: contain;
                    margin-right: 8px;
                }

                .item-text {
                    font-weight: 500;
                    font-size: 12px;
                    color: #FFFFFF;
                    line-height: 18px;
                }
            }
        }
    }

    .bottom {
        font-weight: 500;
        font-size: 11px;
        color: #989898;
        line-height: 15px;
        padding: 25px 0;
        text-align: center;
    }
}
</style>